import {getSelfEmploymentStatusLabel} from './workStatus';

export const WORK_STATUSES_INFO_TITLE = 'О статусах';

export type WorkStatusInfoTaxItem = {
	rate: string;
	description: string;
};

export type WorkStatusInfoSection = {
	id: string;
	title: string;
	intro?: string;
	example?: string;
	taxes?: {
		caption?: string;
		items: WorkStatusInfoTaxItem[];
		note?: string;
	};
	incomeLimit?: string;
	audience?: string;
};

export function getWorkStatusesInfoSections(): WorkStatusInfoSection[] {
	return [
		{
			id: 'self_employment',
			title: getSelfEmploymentStatusLabel(),
			intro: 'Специальный режим для граждан Таможенного союза ЕАЭС с низкой и выгодной налоговой ставкой',
			taxes: {
				caption: 'Самозанятые платят налог по ставкам:',
				items: [
					{rate: '4%', description: 'на доход от физических лиц;'},
					{rate: '6%', description: 'на доход от ИП и юридических лиц.'},
				],
				note: 'Уплата налогов происходит на нашей стороне, вам ничего не нужно делать',
			},
			incomeLimit:
				'Налог на профессиональный доход можно платить, пока сумма дохода нарастающим итогом в течение года не превысит 2,4 млн рублей в год',
			audience:
				'Только гражданам России, Казахстана, Беларуси, Армении и Киргизии, которые подходят по виду деятельности. Их вы можете посмотреть на сайте ФНС',
		},
		{
			id: 'individual',
			title: 'Физическое лицо',
			intro: 'Налоги уплачиваются заказчиком, а задания можно выполнять только после подписания договоров',
			taxes: {
				caption: 'Физические лица платят налог по ставкам:',
				items: [
					{rate: '13%', description: 'НДФЛ (30% для нерезидентов);'},
					{rate: '22%', description: 'взносы в ПФР;'},
					{rate: '5,1%', description: 'взнос ФФОМС.'},
				],
				note: 'Уплата налогов происходит на стороне заказчика, вам ничего не нужно делать',
			},
			incomeLimit: 'Для физических лиц, работающих в рамках договоров ГПХ нет ограничений по доходу',
			audience: 'Гражданам, чей доход в среднем превышает 200 тысяч рублей в месяц или иностранцам',
		},
		{
			id: 'individual_entrepreneur',
			title: 'Индивидуальный предприниматель',
			intro: 'Индивидуальные предприниматели также заключают договоры ГПХ, но налоги уплачивают сами',
			taxes: {
				items: [],
				note: 'Ставка зависит от выбранного режима, а уплата налогов ложится на ваши плечи',
			},
			incomeLimit: 'Для индивидуальных предпринимателей лимиты зависят от выбранного режима налогообложения',
			audience:
				'Предпринимателям, которые планируют нанимать сотрудников для выполнения заданий в приложении',
		},
		{
			id: 'company_representative',
			title: 'Представитель компании',
			intro: 'Физическое лицо представляющее организацию, имеющей право подписи',
			example: 'Например: генеральный директор или иное доверенное лицо',
		},
	];
}
